import setQuery from '@/lib/setQuery';
import { getApps, getWorkflow } from '@/redux/actions/gravityActions';
import { setModalState } from '@/redux/actions/uiActions/modalActions';

const openWorkflowLogsModal = ({ workflowId = null, companyId = null, workflowLogId = null }) => {
  setQuery({ logs: true, search: null, workflowId, logId: workflowLogId });
  setModalState('workflowLogs', { open: true });
  if (workflowId && companyId) {
    getApps({ workflowId, companyId });
    getWorkflow({ id: workflowId, workflowVersion: 'published', isPublished: false });
  }
};

export default openWorkflowLogsModal;
